<template>
  <router-view />
</template>

<script>

export default {
  name: 'AdminLayout'
}
</script>
